import {CreateView} from '../../src/components/_views/configurable/CreateView';
import OrderForm from './OrderForm';
import {withRouterApi} from '../../src/HOCs/withRouterApi';
import {FormViewProps} from '../../src/@types/components/FormViewProps';

export class OrderCreateForm extends CreateView {
    protected getFormComponent() {
        return OrderForm;
    }
}

export default OrderCreateForm.getStoreConnector()(withRouterApi<FormViewProps>(OrderCreateForm));
